export default {
	data() {
		return {
			moduleName: 'versionRedirects',
			detailPageRouteName: 'versionRedirectDetail',
			formIsValid: true,
			updateFields: [
				'id_brand', 'id_device_type', 'version', 'url'
			],
			entity: {
				'id_brand': null,
				'id_device_type': null,
				'version': null,
				'url': null
			},
		}
	},
	methods: {

	}
}



// WEBPACK FOOTER //
// ./src/components/views/versionRedirect/mixins/versionRedirects.js